import { EDITOR_ACTIVE_PAGE_FOCUS_ID, PAGE_CONTAINER_CLASSNAME } from 'modules/Editor/Editor.config';
import { selectZoom } from 'modules/Editor/store/editorSettingsSelector';
import { useAppSelector } from 'modules/Editor/store/hooks';
import {
  selectAllPageBackgroundData,
  selectInfographHeightPx,
  selectInfographWidthPx,
  selectPageBackgroundString,
} from 'modules/Editor/store/infographSelector';
import { selectActivePage } from 'modules/Editor/store/pageSelector';
import { Page } from 'modules/common/components/Page';
import { ReactElement, ReactNode, memo } from 'react';

import { useFocus } from '../Focus';
import { GridOverlay } from './GridOverlay';
import { MarginOverlay } from './MarginOverlay';

export const PageContainer = memo(({ children }: { children: ReactNode }): ReactElement => {
  const activePageId = useAppSelector(selectActivePage);
  const widthPx = useAppSelector(selectInfographWidthPx);
  const heightPx = useAppSelector(selectInfographHeightPx);
  const pageBackgroundString = useAppSelector(selectPageBackgroundString(activePageId));
  const pageBackgroundData = useAppSelector(selectAllPageBackgroundData(activePageId));
  const zoom = useAppSelector(selectZoom);
  const { activePageRef, pageSizeAreaRef, pageScaleAreaRef } = useFocus();

  return (
    <Page
      testId={activePageId}
      className={PAGE_CONTAINER_CLASSNAME}
      bg={pageBackgroundString}
      width={widthPx}
      height={heightPx}
      zoom={zoom}
      tabIndex={0}
      focusElementId={EDITOR_ACTIVE_PAGE_FOCUS_ID}
      focusElementTestId='page-focus-element'
      pageRef={activePageRef}
      pageSizeRef={pageSizeAreaRef}
      pageScaleRef={pageScaleAreaRef}
    >
      <MarginOverlay />
      <GridOverlay pageBackground={pageBackgroundData} hasLargeLineSize={zoom < 0.5} />
      {children}
    </Page>
  );
});
PageContainer.displayName = 'PageContainer';
